import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'

const techStack = [
  {
    name: "OpenAI",
    category: "LLM & Foundation Models",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="currentColor">
        <path d="M21.74 11.23a4.18 4.18 0 0 0-.25-1.92 4.24 4.24 0 0 0-1.48-1.74 8.4 8.4 0 0 0-.17-.85 4.3 4.3 0 0 0-1.07-1.98 4.2 4.2 0 0 0-2-.15 4.22 4.22 0 0 0-3.08-1.37 4.27 4.27 0 0 0-3.23 1.48 4.18 4.18 0 0 0-2-.14 4.22 4.22 0 0 0-2 1.07 4.27 4.27 0 0 0-1.07 1.98 8.8 8.8 0 0 0-.17.85 4.24 4.24 0 0 0-1.48 1.74 4.21 4.21 0 0 0-.25 1.92 4.18 4.18 0 0 0 .25 1.92 4.24 4.24 0 0 0 1.48 1.74c.05.3.1.58.17.85a4.3 4.3 0 0 0 1.07 1.98 4.2 4.2 0 0 0 2 .15 4.22 4.22 0 0 0 3.08 1.37 4.27 4.27 0 0 0 3.23-1.48 4.18 4.18 0 0 0 2 .14 4.22 4.22 0 0 0 2-1.07 4.27 4.27 0 0 0 1.07-1.98c.07-.27.12-.55.17-.85a4.24 4.24 0 0 0 1.48-1.74 4.21 4.21 0 0 0 .25-1.92zm-8.91 7.21a2.82 2.82 0 0 1-2-.83l-4.46-4.46a.7.7 0 0 1 1-1l4.46 4.46a1.41 1.41 0 0 0 2 0l4.46-4.46a.7.7 0 0 1 1 1l-4.46 4.46a2.82 2.82 0 0 1-2 .83zm0-3.92a1.06 1.06 0 1 1 1.06-1.06 1.06 1.06 0 0 1-1.06 1.06zm-4.71-3.66a2.82 2.82 0 0 1 0-4l4.46-4.46a.7.7 0 0 1 1 1l-4.46 4.46a1.41 1.41 0 0 0 0 2l4.46 4.46a.7.7 0 0 1-1 1z"/>
      </svg>
    )
  },
  {
    name: "PyTorch",
    category: "Deep Learning Framework",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.29 14.29c-.39.39-1.02.39-1.41 0L8.29 12.7c-.39-.39-.39-1.02 0-1.41l3.59-3.59c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41L10.41 12l2.88 2.88c.38.39.38 1.03 0 1.41z"/>
      </svg>
    )
  },
  {
    name: "LangChain",
    category: "AI Agent Orchestration",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    )
  },
  {
    name: "Android",
    category: "Mobile AI Integration",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.523 15.3c-.551 0-1.002-.446-1.002-.997 0-.553.45-.998 1.002-.998.551 0 1 .445 1 .998 0 .551-.449.997-1 .997zm-11.046 0c-.551 0-1-.446-1-.997 0-.553.449-.998 1-.998.552 0 1.002.445 1.002.998 0 .551-.45.997-1.002.997zM18.17 9.82l1.64-2.84a.434.434 0 00-.16-.59.43.43 0 00-.59.16l-1.66 2.89C15.905 8.48 14.024 8 12 8c-2.024 0-3.905.48-5.4 1.44L4.94 6.55a.43.43 0 00-.59-.16c-.19.1-.26.34-.16.53l1.63 2.9C2.61 11.97 1.1 14.53 1 17.5h22c-.1-2.97-1.61-5.53-4.83-7.68z"/>
      </svg>
    )
  },
  {
    name: "Kotlin",
    category: "On-Device Processing",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 24H0V0h24L12 12z"/>
      </svg>
    )
  },
  {
    name: "TensorFlow",
    category: "Production ML Services",
    icon: (
      <svg className="w-8 h-8 text-purple-400" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm1 14.5v-5h3v5h-3zm-5 0v-5h3v5H8z"/>
      </svg>
    )
  }
]

const AuthorityBuilders = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

  return (
    <div className="w-full mx-auto px-6 py-12 lg:px-12 lg:py-20 text-slate-850 dark:text-white text-sm" ref={ref}>
      <motion.div 
        className="text-center max-w-2xl mx-auto mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <span className="text-purple-650 dark:text-purple-400 uppercase tracking-widest text-xs font-semibold">Technical Infrastructure</span>
        <h2 className="text-3xl lg:text-4xl font-bold mt-3 bg-gradient-to-r from-slate-850 via-slate-700 to-slate-500 dark:from-white dark:via-purple-100 dark:to-slate-400 bg-clip-text text-transparent">
          Elite Frameworks & Integrations
        </h2>
        <p className="text-slate-550 dark:text-slate-400 text-sm mt-4 font-light leading-relaxed">
          We combine cutting-edge language models and high-performance engineering libraries to architect resilient, scalable corporate intelligence.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
        {techStack.map((tech, index) => (
          <motion.div
            key={tech.name}
            className="flex flex-col items-center justify-between p-6 rounded-2xl border border-slate-200 dark:border-slate-800/80 bg-white dark:bg-slate-900/40 hover-glow animate-float shadow-sm"
            style={{ 
              animationDelay: `${index * 0.4}s`,
              animationDuration: '5s',
              backdropFilter: 'blur(12px)'
            }}
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/20 rounded-xl border border-purple-500/10 mb-4 shadow-[0_0_15px_rgba(168,85,247,0.05)]">
              {tech.icon}
            </div>
            <div className="text-center">
              <h3 className="font-semibold text-slate-800 dark:text-slate-100 text-base">{tech.name}</h3>
              <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-1 uppercase tracking-wider font-light">{tech.category}</p>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="border-b border-slate-200 dark:border-slate-800/60 mt-20"></div>
    </div>
  )
}

export default AuthorityBuilders
